var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyArrowBottomActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03442 5.83458L6.01677 5.83337L5.99908 5.8334C5.92137 5.83355 5.84606 5.80655 5.78616 5.75708C5.78602 5.75696 5.78588 5.75685 5.78574 5.75673L0.786786 1.59096L0.786294 1.59055C0.718094 1.53386 0.675206 1.4524 0.667064 1.3641C0.658922 1.27579 0.686194 1.18787 0.742879 1.11967C0.799565 1.05147 0.881022 1.00858 0.969331 1.00044C1.05747 0.992312 1.14522 1.01946 1.21336 1.07592C1.2135 1.07603 1.21363 1.07614 1.21377 1.07625L5.6794 4.80871L5.99429 5.0719L6.31382 4.81437L10.7805 1.21437L10.7819 1.2132C10.816 1.18552 10.8553 1.16484 10.8974 1.15236C10.9395 1.13988 10.9837 1.13585 11.0273 1.1405C11.071 1.14515 11.1133 1.15838 11.1519 1.17944L11.3916 0.740646L11.1519 1.17944C11.1904 1.20049 11.2244 1.22896 11.2519 1.26321L11.2599 1.27312L11.2684 1.28262C11.2989 1.31689 11.322 1.3571 11.3363 1.40073C11.3505 1.44435 11.3556 1.49045 11.3513 1.53614C11.3469 1.58183 11.3331 1.62612 11.3108 1.66624C11.2885 1.70635 11.2582 1.74144 11.2217 1.76929L11.2216 1.76915L11.2115 1.77725L6.23107 5.78651C6.1722 5.82247 6.1035 5.83934 6.03442 5.83458Z",
    fill: "#1062D0",
    stroke: "#1062D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyArrowBottomActive);
export default __webpack_public_path__ + "static/media/currency-arrow-bottom-active.bdfa80d1dd9d43fc425e358e85e4c317.svg";
export { ForwardRef as ReactComponent };